import React from 'react';
import { FSFMotoLightBoxStore } from '../../_flux/stores/fsf_moto_light_box_store';
import { FSFMotoLightBox } from '../../_flux/components/fsf_moto_light_box/fsf_moto_light_box';
import { hideAction } from '../../_flux/actions/fsf_moto_light_box_actions';
import { handleView } from '../handle_view';

const stores = {
    state: FSFMotoLightBoxStore
};

const render = ({ state }) => (
    <FSFMotoLightBox
        visible={state.visible}
        onClose={hideAction}
    />
);

export const init = (container) =>
    handleView(stores, render, {}, container);
